import { toggleItem } from './../common/utils/array';
import { compose, prop, find, map } from 'lodash/fp';
import { assocPath } from 'rambda';
import { TeamRequestAction } from '.';
import { deleteApiCallStatus, IApiCallStatus, IDeaNumUser } from '../common';

// const deanumUsers = [
//   {
//     key: '155461',
//     deaInfoId: 155461,
//     userProfileId: 372,
//     role: 'PRN',
//     firstName: 'CSOS',
//     lastName: 'USER3',
//     loginEmail: 'CSOS.USER3@MYACUITY.COM',
//     deaNumber: 'AB0020777',
//     serialNumber: 'C2022042715294937200001',
//   },
//   {
//     key: '155462',
//     deaInfoId: 155462,
//     userProfileId: 372,
//     role: 'PRN',
//     firstName: 'CSOS',
//     lastName: 'USER3',
//     loginEmail: 'CSOS.USER3@MYACUITY.COM',
//     deaNumber: 'BB00207772',
//     serialNumber: 'C2022042715294937200001',
//   },
//   {
//     key: '155463',
//     deaInfoId: 155463,
//     userProfileId: 372,
//     role: 'PRN',
//     firstName: 'CSOS',
//     lastName: 'USER3',
//     loginEmail: 'CSOS.USER3@MYACUITY.COM',
//     deaNumber: 'CB0020777',
//     serialNumber: 'C2022042715294937200001',
//   },
// ];

export interface ITeamRequestInput {
  reqType: string;
  comments: string | null;
  otherComments: string | null;
  status: string;
}

export interface IRequestApiCallStatus {
  type: 'SaveRequest' | 'ConfirmSubmitRequest';
  apiCallStatus: IApiCallStatus;
}
export interface ITeamRequestState {
  request: ITeamRequestInput;
  deaNum: string | null;
  email: string | null;
  serialNumber: string | null;
  firstName: string | null;
  lastName: string | null;

  deanumUsers: IDeaNumUser[];
  selectedUserRoleKeys: string[];
  apiCallStatus: IRequestApiCallStatus[];
}

export const saveRequestStatus = compose(
  prop('apiCallStatus'),
  find<IRequestApiCallStatus>({ type: 'SaveRequest' }),
  prop('apiCallStatus')
);

export const initTeamRequestState: ITeamRequestState = {
  request: {
    reqType: 'REVOKE',
    comments: null,
    otherComments: null,
    status: 'NEW',
  },
  deaNum: null,
  email: null,
  serialNumber: null,
  firstName: null,
  lastName: null,

  deanumUsers: [],
  selectedUserRoleKeys: [],
  apiCallStatus: [],
};

export const teamRequestReducer = (
  state: ITeamRequestState,
  { type, payload }: TeamRequestAction
): ITeamRequestState => {
  switch (type) {
    // justification

    case 'SetJustification':
      return compose(
        assocPath<ITeamRequestState>('request.comments', payload as string)
      )(state);

    case 'SetOtherComments':
      return compose(
        assocPath<ITeamRequestState>('request.otherComments', payload as string)
      )(state);

    // deaNum

    case 'SetDeaNum':
      return compose(
        assocPath<ITeamRequestState>('firstName', null),
        assocPath<ITeamRequestState>('lastName', null),
        assocPath<ITeamRequestState>('serialNumber', null),
        assocPath<ITeamRequestState>('email', null),
        assocPath<ITeamRequestState>('deaNum', payload as string)
      )(state);

    case 'SetEmail':
      return compose(
        assocPath<ITeamRequestState>('firstName', null),
        assocPath<ITeamRequestState>('lastName', null),
        assocPath<ITeamRequestState>('serialNumber', null),
        assocPath<ITeamRequestState>('email', payload as string),
        assocPath<ITeamRequestState>('deaNum', null)
      )(state);

    case 'SetSerialNumber':
      return compose(
        assocPath<ITeamRequestState>('firstName', null),
        assocPath<ITeamRequestState>('lastName', null),
        assocPath<ITeamRequestState>('serialNumber', payload as string),
        assocPath<ITeamRequestState>('email', null),
        assocPath<ITeamRequestState>('deaNum', null)
      )(state);

    case 'SetFirstName':
      return compose(
        assocPath<ITeamRequestState>('firstName', payload as string),
        // assocPath<ITeamRequestState>('lastName', null),
        assocPath<ITeamRequestState>('serialNumber', null),
        assocPath<ITeamRequestState>('email', null),
        assocPath<ITeamRequestState>('deaNum', null)
      )(state);

    case 'SetLastName':
      return compose(
        // assocPath<ITeamRequestState>('firstName', null),
        assocPath<ITeamRequestState>('lastName', payload as string),
        assocPath<ITeamRequestState>('serialNumber', null),
        assocPath<ITeamRequestState>('email', null),
        assocPath<ITeamRequestState>('deaNum', null)
      )(state);

    case 'SetDeaNumUsers':
      return compose(
        assocPath<ITeamRequestState>('deanumUsers', payload as IDeaNumUser[])
      )(state);

    case 'ToggleUserRole':
      return payload === 'all'
        ? compose(
            assocPath<ITeamRequestState>(
              'selectedUserRoleKeys',
              state.deanumUsers.length === state.selectedUserRoleKeys.length
                ? []
                : compose(
                    map<IDeaNumUser, string>(prop('key')),
                    prop('deanumUsers')
                  )(state)
            )
          )(state)
        : compose(
            assocPath<ITeamRequestState>(
              'selectedUserRoleKeys',
              toggleItem(state.selectedUserRoleKeys)(payload)
            )
          )(state);

    case 'SaveRequestSuccess':
      return compose(
        assocPath<ITeamRequestState>('apiCallStatus', [
          ...deleteApiCallStatus({ type: 'SaveRequest' })(state.apiCallStatus),
          { type: 'SaveRequest', apiCallStatus: true },
        ])
      )(state);

    case 'SaveRequestError':
      return compose(
        assocPath<ITeamRequestState>('apiCallStatus', [
          ...deleteApiCallStatus({ type: 'SaveRequest' })(state.apiCallStatus),
          { type: 'SaveRequest', apiCallStatus: false },
        ])
      )(state);

    default:
      return state;
  }
};
